const primaryMain = '#AA0000';
const primaryMainOpacity = 'rgba(170, 0, 0, 0.9)';
const secondaryMain = '#EF4135';
const secondaryMainOpacity = 'rgba(239, 65, 53, 0.5)';
const secondaryLight = '#ea7a71';
const tertiaryMain = '#a84141';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
